import { FeaturesType } from "@rcsb/rcsb-api-tools/lib/RcsbGraphQL/Types/Borrego/GqlTypes";
const BURIAL_FRACTION = "BURIAL_FRACTION";
const BURIED_RESIDUES = "BURIED_RESIDUES";
const ExtendedTypes = {
    BurialFraction: BURIAL_FRACTION,
    BuriedResidues: BURIED_RESIDUES
};
const MergedType = Object.assign(Object.assign({}, FeaturesType), ExtendedTypes);
export const FeatureType = MergedType;
//# sourceMappingURL=FeatureType.js.map